module.exports = __webpack_public_path__ + "static/media/mill-critical.d0b9b04f.svg";